import { url } from '@tencent/wphk-base-utils';
import { CDKEY_RAW_MAX_LENGTH } from '../components/format-input/format-type';

/**
 * URL query 预填兑换码：仅接受字符串（重复 `?cdkey=a&cdkey=b` 收窄为数组 → 视为空），
 * 先去空格再截断到 CDKEY_RAW_MAX_LENGTH（16）位有效字符——和手输路径一致：
 * 手输受 `<input maxlength>` 限制为 16 位有效（含空格 19 位），URL 预填若不截断会出现
 * 「URL 进来 19 位、手输只能 16 位」的不一致。
 *
 * 顺序不可颠倒（先去空格再截断）：边界 case 如 `?cdkey=AAAA%20BBBB%20CCCC%20DDDD`
 * （含空格但去空格后正好 16 位）若先截断会丢字符。
 */
export function pickInitialCdkey(raw: unknown): string {
  return typeof raw === 'string' ? raw.replace(/\s+/g, '').slice(0, CDKEY_RAW_MAX_LENGTH) : '';
}

/**
 * URL 一次性消费：把 cdkey 从 location.search 抹掉，
 * 让用户离开本页后再回来不会被强制重新预填（spec.md Part 2 Q6 已与产品确认）。
 *
 * 选用 history.replaceState 而非 router.replace 的原因：
 *   1) hash 模式下 router.replace 无法清 location.search；
 *   2) replaceState 不触发 vue-router 的 beforeEach，已在 setup 持有的 cdkey ref 不受影响；
 *   3) 不新增 history 条目，用户的"返回"按钮行为符合预期。
 */
export function stripCdkeyFromUrl(): void {
  const { href } = window.location;
  const next = url.removeUrlParam(href, 'cdkey');
  if (next !== href) {
    window.history.replaceState(window.history.state, '', next);
  }
}
